import React from 'react';

export default function Step3Caixas({
  operation, totalVencidas, nomesVencidas, estoqueRows,
  preferSaidaVencidas, setPreferSaidaVencidas, uniqueCaixas,
  totalSelecionadas, caixaInputRef, codigo, setCodigo,
  highlightIndex, setHighlightIndex, suggestions, addCaixa,
  buscarCaixa, avancarButtonRef, stockByBox, adjustQty,
  setQtyForBox, removerCaixa, limparTudo, totalEstoqueAtual,
  BADGE_STYLES, vencidasByBoxName, vencidoByBoxName
}) {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl shadow p-6">
        {operation === 'saida' && totalVencidas > 0 && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded">
            <div className="text-xs text-red-800">
              <p className="mb-2">
                Existem <b>{totalVencidas}</b> entrada(s) <b>vencida(s)</b> em estoque
                {nomesVencidas ? ` (ex.: ${nomesVencidas}${(estoqueRows || []).filter(r => (Number(r.saldo)||0)>0 && (Number(r.vencidas)||0)>0).length > 6 ? ', …' : ''})` : ''}.
              </p>
              <div className="flex items-center gap-3">
                <span className="font-medium">Priorizar saída das caixas vencidas?</span>
                <label className="inline-flex items-center gap-1 cursor-pointer">
                  <input type="radio" name="prefer-saida" onChange={() => setPreferSaidaVencidas(true)} checked={preferSaidaVencidas === true} />
                  <span>Sim</span>
                </label>
                <label className="inline-flex items-center gap-1 cursor-pointer">
                  <input type="radio" name="prefer-saida" onChange={() => setPreferSaidaVencidas(false)} checked={preferSaidaVencidas === false} />
                  <span>Não</span>
                </label>
              </div>
            </div>
          </div>
        )}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Informar Caixas</h3>
          {uniqueCaixas.length > 0 && (
            <div className="text-sm text-gray-700">
              Total de unidades selecionadas: <b>{totalSelecionadas}</b>
            </div>
          )}
        </div>
        <div className="flex gap-4">
          <input
            ref={caixaInputRef}
            type="text"
            placeholder="Código ou nome da caixa"
            value={codigo}
            onChange={e => setCodigo(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'ArrowDown') {
                e.preventDefault()
                setHighlightIndex(prev => {
                  const next = prev + 1
                  return Math.min(next, (suggestions?.length || 0) - 1)
                })
                return
              }
              if (e.key === 'ArrowUp') {
                e.preventDefault()
                setHighlightIndex(prev => Math.max(prev - 1, 0))
                return
              }
              if (e.key === 'Enter') {
                e.preventDefault()
                const hasText = codigo.trim().length > 0
                if (!hasText) {
                  avancarButtonRef.current?.focus()
                  return
                }
                const idx = highlightIndex
                if (idx >= 0 && suggestions && suggestions[idx]) {
                  addCaixa(suggestions[idx])
                } else {
                  buscarCaixa()
                }
                setTimeout(() => caixaInputRef.current?.focus(), 0)
                return
              }
            }}
            className="flex-1 border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-300"
          />
          <button
            onClick={buscarCaixa}
            className="bg-[#0095DA] hover:brightness-110 text-white px-6 rounded-full"
          >
            Adicionar
          </button>
        </div>
        {suggestions.length > 0 && (
          <ul className="mt-2 border rounded shadow max-h-40 overflow-y-auto">
            {suggestions.map((c, i) => (
              <li
                key={c.id}
                onClick={() => addCaixa(c)}
                onMouseEnter={() => setHighlightIndex(i)}
                className={`px-3 py-2 cursor-pointer ${highlightIndex === i ? 'bg-blue-100' : 'hover:bg-gray-100'}`}
              >
                {c.nome} ({c.codigo_barras})
              </li>
            ))}
          </ul>
        )}
        {uniqueCaixas.length > 0 && (
          <div className="flex flex-col gap-2 mt-4">
            {uniqueCaixas.map(c => {
              const disponivel = operation === 'saida' ? (stockByBox[c.nome] || 0) : null
              const semSaldo = operation === 'saida' && (!disponivel || disponivel <= 0)
              const excedeSaldo = operation === 'saida' && !!disponivel && (Number(c.qty) || 1) > disponivel
              const maxSaida = operation === 'saida' ? (disponivel || 0) : 99
              const max = Math.max(semSaldo ? 0 : 1, maxSaida)
              return (
                <div key={c.id} className={`bg-gray-50 border ${semSaldo || excedeSaldo ? 'border-red-300' : 'border-gray-200'} px-3 py-2 rounded-lg`}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="font-medium text-gray-800">{c.nome}</div>
                      {operation === 'saida' && (
                        <>
                          {semSaldo && (
                            <span className="hidden md:inline text-xs text-red-600">Sem estoque para saída desta caixa.</span>
                          )}
                          {!semSaldo && excedeSaldo && (
                            <span className="hidden md:inline text-xs text-red-600">Quantidade solicitada excede estoque ({disponivel}).</span>
                          )}
                        </>
                      )}
                    </div>
                    <div className="flex items-center gap-2">
                      <label className="text-[11px] md:text-xs text-gray-600">Qtd</label>
                      <button
                        type="button"
                        onClick={() => adjustQty(c.id, -1)}
                        disabled={semSaldo}
                        className={`w-6 h-6 md:w-7 md:h-7 text-xs md:text-sm flex items-center justify-center rounded border ${semSaldo ? 'text-gray-300 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-100'}`}
                        title="Diminuir"
                      >−</button>
                      <input
                        type="number"
                        min={semSaldo ? 0 : 1}
                        max={max}
                        value={Math.min(Number(c.qty) || 0, max)}
                        onChange={e => setQtyForBox(c.id, e.target.value)}
                        disabled={semSaldo}
                        onKeyDown={e => {
                          if (e.key === 'ArrowUp') { e.preventDefault(); if (!semSaldo) adjustQty(c.id, 1) }
                          if (e.key === 'ArrowDown') { e.preventDefault(); if (!semSaldo) adjustQty(c.id, -1) }
                        }}
                        className={`w-12 md:w-16 border rounded px-2 py-1 text-xs md:text-sm text-center focus:outline-none ${semSaldo ? 'bg-gray-100 text-gray-400' : 'focus:ring-2 focus:ring-blue-300'}`}
                      />
                      <button
                        type="button"
                        onClick={() => adjustQty(c.id, 1)}
                        disabled={semSaldo}
                        className={`w-6 h-6 md:w-7 md:h-7 text-xs md:text-sm flex items-center justify-center rounded border ${semSaldo ? 'text-gray-300 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-100'}`}
                        title="Aumentar"
                      >+</button>
                      <button
                        onClick={() => removerCaixa(c.id)}
                        className="ml-1 w-5 h-5 md:w-6 md:h-6 flex items-center justify-center rounded-full bg-red-500 text-white hover:bg-red-600"
                        title="Remover caixa da lista"
                        aria-label="Remover caixa da lista"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                  {operation === 'saida' && (
                    <div className="mt-1 text-xs md:hidden">
                      {semSaldo && (
                        <span className="text-red-600">Sem estoque para saída desta caixa.</span>
                      )}
                      {!semSaldo && excedeSaldo && (
                        <span className="text-red-600">Quantidade solicitada excede estoque ({disponivel}).</span>
                      )}
                    </div>
                  )}
                </div>
              )
            })}
            <div className="flex justify-end pt-2">
              <button
                type="button"
                onClick={limparTudo}
                className="inline-flex items-center gap-2 text-sm text-gray-700 hover:text-red-700 px-2 py-1 rounded"
                title="Limpar todas as caixas selecionadas"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eraser-icon lucide-eraser">
                  <path d="M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21"/>
                  <path d="m5.082 11.09 8.828 8.828"/>
                </svg>
                <span>Limpar tudo</span>
              </button>
            </div>
          </div>
        )}
      </div>

      {Object.keys(stockByBox).length > 0 && (
        <div className="bg-white rounded-2xl p-6">
          <h4 className="font-medium mb-2 flex items-center justify-between">
            Estoque Atual do Aluno
            <span className="text-sm font-semibold text-blue-800 bg-blue-100 px-2 py-0.5 rounded-full">Total: {totalEstoqueAtual}</span>
          </h4>
          <div className="flex flex-wrap gap-2">
            {Object.entries(stockByBox).map(([nome, qty], i) => (
              <div
                key={nome}
                className={`px-3 py-1 rounded-full font-semibold ${BADGE_STYLES[i % BADGE_STYLES.length]} flex items-center gap-2`}
              >
                <span>{nome}: {qty}</span>
                {vencidasByBoxName[nome] > 0 ? (
                  <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] bg-red-100 text-red-700 border border-red-200">Vencido: {vencidasByBoxName[nome]}</span>
                ) : (
                  vencidoByBoxName[nome] && (
                    <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] bg-red-100 text-red-700 border border-red-200">Vencido</span>
                  )
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}